import {UWM_NAVIGATE_TYPES} from '@uwm/host';
import modalService from '@/services/modal/modalService';
import uwmMessageService from '@/services/uwm/uwmMessageService';
import {type ButtonAction, ButtonActionItems, type ButtonModel} from '@/types/aem';

/** Actions this module handles itself; anything else is a host route and goes to the PWA verbatim. */
const internalActions = new Map<ButtonAction, (code?: string) => void>([
    [
        ButtonActionItems.UwmModuleOpenMetricDetail,
        (code) => {
            if (code) modalService.openDetail(code);
        },
    ],
]);

/** Single entry point for an authored button - tracking and navigation always travel together. */
const run = (button: ButtonModel = {}, code?: string) => {
    const {action, trackingValue, tipsGroupType, deviceSettingType} = button;

    if (trackingValue) uwmMessageService.sendTrackAnalytics(trackingValue, {insightId: code});

    if (!action) return;

    if (action === ButtonActionItems.UwmModuleNavigateToDeviceSettings) {
        uwmMessageService.sendNavigateTo(
            UWM_NAVIGATE_TYPES.UWM_MODULE_NAVIGATE_TO_DEVICE_PERSONALIZE,
            deviceSettingType ? {deviceSettingType} : undefined
        );

        return;
    }

    const internal = internalActions.get(action);

    if (internal) {
        internal(code);

        return;
    }

    uwmMessageService.sendNavigateTo(action, tipsGroupType ? {tipsGroupType} : undefined);
};

export default {run};
